import React, { useEffect, useRef } from 'react';
import Webcam from '@/libs/utils/webcam';
import AiLabPageShell from '@/components/ai-lab-page-shell/AiLabPageShell';

function FaceRealCheck() {
  const webcamRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    // 初始化摄像头
    const initWebcam = async () => {
      try {
        webcamRef.current = new Webcam();
        await webcamRef.current.setup();
        await webcamRef.current.play();

        // 将视频元素挂载到DOM
        if (videoRef.current) {
          videoRef.current.appendChild(webcamRef.current.webcam);
        }
      } catch (error) {
        console.error('摄像头初始化失败:', error);
      }
    };

    initWebcam();

    // 清理函数
    return () => {
      if (webcamRef.current) {
        webcamRef.current.stop().catch((e) => {
          console.error('摄像头关闭失败:', e);
        });
      }
    };
  }, []);

  return (
    <AiLabPageShell>
      <h2>人脸实时检测</h2>
      <div ref={videoRef} style={{ width: 300, height: 300 }} />
    </AiLabPageShell>
  );
}

export default FaceRealCheck;
